import { render, staticRenderFns } from "./SendProposal.vue?vue&type=template&id=2e1e207c&"
import script from "./SendProposal.vue?vue&type=script&lang=js&"
export * from "./SendProposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports